// import { processDroneImages } from "api/pointCloud";
import fileExplorerConfig from "config/fileExplorerConfig";
import fileUploaderApiConfig from "config/fileUploaderApiConfig";
import projectDateConfig from "config/projectDateConfig";

const settingsModalConfig = {
  processDroneImages: () => null,
  fileUploaderApiConfig,
  fileExplorerConfig,
  projectDateConfig
};

export default settingsModalConfig;